import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BusinessUser } from '@models/businesses';
import { Select } from '@ngxs/store';
import { BusinessUsersState } from '@state/business-users/business-users.state';
import { Observable } from 'rxjs';
import { DropdownResult } from '../../atomic/atoms/dropdown-options/dropdown-options.component';
import { take } from 'rxjs/operators';

@Component({
	selector: 'app-business-user-dropdown',
	templateUrl: './business-user-dropdown.component.html',
	standalone: false,
})
export class BusinessUserDropdownComponent {
	@Select(BusinessUsersState.getActiveUsers) all$: Observable<BusinessUser[]>;

	@Input() placeholder: string;
	@Input() label: string;
	@Input() set userId(userId: string) {
		this.selectedUserId = userId;

		if (userId) {
			this.all$.pipe(take(1)).subscribe((users) => {
				if (this.selectedUserId) {
					const selected = users.find((x) => x.id === this.selectedUserId);

					if (selected) {
						this.selectedDropDownValue = `${selected.firstName} ${selected.lastName}`;
					}
				}
			});
		} else {
			this.selectedDropDownValue = null;
		}
	}

	@Output() selected: EventEmitter<BusinessUser> =
		new EventEmitter<BusinessUser>();

	public selectedDropDownValue: string;
	public list: BusinessUser[];
	private selectedUserId: string;

	onSelect($event: DropdownResult<BusinessUser>) {
		this.selectedUserId = $event.result.id;
		this.selectedDropDownValue = `${$event.result.firstName} ${$event.result.lastName}`;
		this.selected.emit($event.result);
	}
}
